import React from 'react';

interface CreateHomeworkProps {
  domain: string;
}

const CreateHomework: React.FC<CreateHomeworkProps> = ({ domain: _domain }) => {
  return (
    <div className="card shadow-sm">
      <div className="card-header bg-white py-3">
        <h5 className="mb-0">
          <i className="bi bi-journal-text me-2 text-primary-custom"></i>
          Create Homework
        </h5>
        <small className="text-muted">Assign daily homework to students</small>
      </div>
      <div className="card-body">
        <p className="text-muted">Homework module - Similar structure to Assignments with shorter deadlines</p>
      </div>
    </div>
  );
};

export default CreateHomework;
